import axios from 'axios';
import { ICoordinates } from 'libs/types/map/mapTypes';
import { Transport } from 'react-give-me-map';

interface Return {
    waypoints: ICoordinates[];
    path: ICoordinates[];
}

export function getTransportPath(
    transport: Transport,
    coordinates: ICoordinates[]
): Promise<Return> {
    if (transport === 'plane') {
        return Promise.resolve({ waypoints: coordinates, path: coordinates });
    } else {
        const points = coordinates.map(({ lat, lng }) => `${lng},${lat}`).join(';');
        return axios({
            method: 'GET',
            url: `https://api.mapbox.com/directions/v5/mapbox/${transport}/${points}?geometries=geojson&overview=full&access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`,
            headers: {},
            params: {},
            data: {}
        }).then((r) => {
            console.log('r.data', r.data);
            const path: ICoordinates[] = r.data?.routes?.[0].geometry.coordinates?.map((c) => ({
                lng: c[0],
                lat: c[1]
            }));
            const waypoints = r.data?.waypoints.map((c) => ({
                lng: c.location[0],
                lat: c.location[1]
            }));
            console.log('waypoints', waypoints);
            return { waypoints, path };
        });
    }
}
